/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('offersPanelCheckOut', {
    templateUrl: 'app/components/offers/panel/checkOut/CheckOut.html',
    controller: PanelCheckOut,
    bindings: {
      checkOut: '<',
      onClick: '&'
    }
  });

function PanelCheckOut($rootScope, PanelObserver, $translate) {
  var $this = this;
  $this.$rootScope = $rootScope;
  $this.PanelObserver = PanelObserver;
  $this.$translate = $translate;
  $this.isOpen = false;
  $this.datepickerOptions = {
    maxMode: 'month',
    showWeeks: false,
    startingDay: 1
  };
  $this.$rootScope.$on('changeCheckIn', function (event, data) {
    $this.handleCheckInChange(data);
  });
}

PanelCheckOut.prototype = {
  $onInit: function () {
    var checkIn = this.PanelObserver.getCheckIn();
    this.checkOut = moment(this.checkOut).toDate();
    this.PanelObserver.setCheckOut(this.checkOut);
    this.datepickerOptions.minDate = moment(checkIn).add(1, 'day').toDate();
  },

  $onChanges: function () {
    this.PanelObserver.setCheckOut(null);
  },

  handleClick: function () {
    this.isOpen = !this.isOpen;
    this.onClick();
  },

  handleChange: function () {
    this.PanelObserver.setCheckOut(this.checkOut);
  },

  handleCheckInChange: function (checkIn) {
    if (moment(checkIn).isSameOrAfter(moment(this.checkOut))) {
      this.checkOut = moment(checkIn).add(1, 'day').toDate();
    }
    this.handleChange();
    this.datepickerOptions.minDate = moment(checkIn).add(1, 'day').toDate();
  },

  getYear: function () {
    return moment(this.checkOut).year();
  },

  getMonth: function () {
    var monthIndex = moment(this.checkOut).month();
    var monthList = [
      this.$translate.instant('months_short.JAN'),
      this.$translate.instant('months_short.FEB'),
      this.$translate.instant('months_short.MAR'),
      this.$translate.instant('months_short.APR'),
      this.$translate.instant('months_short.MAY'),
      this.$translate.instant('months_short.JUN'),
      this.$translate.instant('months_short.JUL'),
      this.$translate.instant('months_short.AUG'),
      this.$translate.instant('months_short.SEP'),
      this.$translate.instant('months_short.OCT'),
      this.$translate.instant('months_short.NOV'),
      this.$translate.instant('months_short.DEC')
    ];
    return monthList[monthIndex];
  },

  getDay: function () {
    var dayOfWeek = moment(this.checkOut).day();
    var dayList = [
      this.$translate.instant('weekdays.SUNDAY'),
      this.$translate.instant('weekdays.MONDAY'),
      this.$translate.instant('weekdays.TUESDAY'),
      this.$translate.instant('weekdays.WEDNESDAY'),
      this.$translate.instant('weekdays.THURSDAY'),
      this.$translate.instant('weekdays.FRIDAY'),
      this.$translate.instant('weekdays.SATURDAY')
    ];
    return dayList[dayOfWeek];
  },

  getDayNumber: function () {
    var day = moment(this.checkOut).date();
    return day < 10 ? '0' + day : day;
  }
};
